import { create } from "zustand";
import type { ScrollStoreType } from "./ScrollStore.d";

export const useScrollStore = create<ScrollStoreType>((set) => ({
  isAnchorInView: false,
  setAnchorInView: (value) => set(() => ({ isAnchorInView: value })),
}));
